/**
 * Style of surfaces component cat. consists of
 * - appBarStyles,
 * - toolbarStyles,
 * - paperStyles,
 * - cardStyles,
 *  and etc.
 */

/**
 * toolbarStyles for AppBar position=fixed
 * @param {*} theme
 */
export const appBarStyles = (theme) => {
  // Default drawer width
  const drawerWidth = '240';

  // themeMixinsToolbar is the poperty of theme toolbar
  const themeMixinsToolbar = { ...theme.mixins.toolbar };

  // Re-Create themeMixinsToolbar with mixinsToolbar
  // Let simplify to apply to toolbarStyle.
  const mixinsToolbar = {
    minHeight: themeMixinsToolbar.minHeight,
    upxs: {
      minHeight:
        themeMixinsToolbar[
          `${theme.breakpoints.up('xs')} and (orientation: landscape)`
        ].minHeight,
    },
    upsm: {
      minHeight: themeMixinsToolbar[theme.breakpoints.up('sm')].minHeight,
    },
  };
  const toolbarStyleOffsetHeight = 25;

  // Toolbar Style
  const toolbarStyle = {
    padding: theme.spacing(1),
    minHeight: mixinsToolbar.minHeight - toolbarStyleOffsetHeight,
    [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
      minHeight: mixinsToolbar.upxs.minHeight - toolbarStyleOffsetHeight,
    },
    [theme.breakpoints.up('sm')]: {
      minHeight: mixinsToolbar.upsm.minHeight - toolbarStyleOffsetHeight,
    },
  };

  //Return appToolBarStyle
  return {
    //Set top appToolBar (Let appToolBar is under the window + AbbBar)
    appToolBarStyle: {
      flexGrow: 1,
      top: mixinsToolbar.minHeight,
      [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
        top: mixinsToolbar.upxs.minHeight,
      },
      [theme.breakpoints.up('sm')]: {
        top: mixinsToolbar.upsm.minHeight,
      },
      color: '#000000',
      background: '#FFFFFF',
      borderBottom: '1px solid #e0e0e0',
      // boxShadow: 'none',
    },
    // toolbarStyle
    toolbarStyle,
    // necessary for content to be below AppToolBar
    toolbarOffsetStyle: toolbarStyle,
  };
};
